/** Defines the TaskMutationsContext and a hook to access it safely. */
// @ts-check
import { createContext, useContext } from 'react';

export const TaskMutationsContext = createContext(null);

export const useTaskMutationsContext = () => {
  const context = useContext(TaskMutationsContext);
  if (!context) {
    throw new Error(
      'useTaskMutationsContext must be used within a TaskMutationsProvider',
    );
  }
  return context;
};
